export default function MesswertInputComponent(props) {
    const formFactory = props.formFactory;

    const inputsConfig = {
        datumsformat: {
            render: (index) => formFactory.renderInput(`messwerte.${index}.datum`, `messwerte.${index}.datum`, `Datum`),
            conditionKey: null
        },
        uhrzeit: {
            render: (index) => formFactory.renderInput(`messwerte.${index}.uhrzeit`, `messwerte.${index}.uhrzeit`, "Uhrzeit"),
            conditionKey: 'uhrzeit'
        },
        wetterschluessel: {
            render: (index) => formFactory.renderInput(`messwerte.${index}.wetterSchluessel`, `messwerte.${index}.wetterSchluessel`, "Wetterschlüssel"),
            conditionKey: 'wetterschluessel'
        },
        schwelle: {
            render: (index) => formFactory.renderInput(`messwerte.${index}.schwelle`, `messwerte.${index}.schwelle`, "Schwelle"),
            conditionKey: 'schwelle'
        },
        wert: {
            render: (index) => formFactory.renderNumberInput(`messwerte.${index}.wert`, `messwerte.${index}.wert`, `Wert`, props.values?.anforderungsParameterArt === 'Fracht'),
            conditionKey: 'wert'
        },
        anzahl: {
            render: (index) => formFactory.renderNumberInput(`messwerte.${index}.anzahl`, `messwerte.${index}.anzahl`, "Messwerte Anzahl"),
            conditionKey: 'messwertAnzahl'
        },
        anzahl12Grad: {
            render: (index) => formFactory.renderNumberInput(`messwerte.${index}.anzahl12Grad`, `messwerte.${index}.anzahl12Grad`, "Messwert Anzahl >=12°C"),
            conditionKey: 'messwertAnzahlGreater12'
        },
        maximalwert: {
            render: (index) => formFactory.renderNumberInput(`messwerte.${index}.maximalwert`, `messwerte.${index}.maximalwert`, "Messwert Maximalwert"),
            conditionKey: 'messwertMaxWert'
        },
        maximalwertQ: {
            render: (index) => formFactory.renderNumberInput(`messwerte.${index}.maximalwertQ`, `messwerte.${index}.maximalwertQ`, "Messwert Maximal Q"),
            conditionKey: 'messwertMaxQ'
        },
        konzentration: {
            render: (index) => formFactory.renderNumberInput(`messwerte.${index}.konzentration`, `messwerte.${index}.konzentration`, "Konzentration"),
            conditionKey: 'konzentration'
        },
        abfluss: {
            render: (index) => formFactory.renderNumberInput(`messwerte.${index}.abfluss`, `messwerte.${index}.abfluss`, "Wassermenge"),
            conditionKey: 'abfluss'
        },
    };

    const renderInputs = () => {
        if (!props.vorlage) {
            return EmptyVorlageInput();
        }

        let inputs = [];
        for (let index = 0; index < props.anzahl; index++) {
            let rowInputs = [];
            Object.entries(inputsConfig).forEach(([inputName, config]) => {
                if (config.conditionKey === null || props.vorlage[config.conditionKey]) {
                    rowInputs.push(config.render(index));
                }
            });
            inputs.push(<div style={{ display: 'flex', justifyContent: 'flex-start' }}>{rowInputs}</div>);
        }
        return inputs;
    };

    function EmptyVorlageInput() {
        return (
            <div className={"red-bold"}>
                Es wurde keine Vorlage ausgewählt.
            </div>
        );
    }

    return (
        <div className="gridl" style={{ margin: "10px", marginTop: "20px" }}>
            {renderInputs()}
        </div>
    )
}
